import {
    Datagrid,
    TextField,
    SelectField,
    NumberField,
    ReferenceField,
    ReferenceInput,
    AutocompleteInput,
    required,
    usePermissions,
    useTranslate,
} from 'react-admin';
import { SearchBar } from '@/components/global/list/searchBar.jsx';

import CustomList from '@/components/global/list/CustomList.jsx';
import { CustomListNoResults } from '@/components/global/list/CustomListNoResults.jsx';
import { createFilterToQuery } from '@/helpers/filters/filterToQuery.js';

export const sources = [
    { id: 'GS1', name: 'GS1' },
    { id: 'operator', name: 'operator' },
    { id: 'client', name: 'client' },
    { id: 'manual', name: 'manual' },
    { id: 'AI', name: 'AI' },
    { id: 'rvm', name: 'RVM' },
];

const categoryFilterToQuery = createFilterToQuery(['name']);

export const TagList = () => {
    const { isLoading } = usePermissions();
    const translate = useTranslate();
    if (isLoading) return null;
    const filters = [
        <SearchBar key='search' source='value' label={translate('common.search')} alwaysOn />,
        <ReferenceInput key='categoryId' source='categoryId' reference='tag-category' label={translate('common.category')} perPage={25}>
            <AutocompleteInput filterToQuery={categoryFilterToQuery} validate={required(translate('common.validation.required'))} fullWidth={true} />
        </ReferenceInput>,
    ];
    return (
        <CustomList filters={filters}>
            <Datagrid bulkActionButtons={false} empty={<CustomListNoResults />}>
                <TextField source='name' label={translate('common.name')} />
                <SelectField source='source' choices={sources} label={translate('resources.sercieRequest.labels.sourceTitle')} />
                <ReferenceField source='categoryId' reference='tag-category' label={translate('common.category')} />
                <NumberField source='sortOrder' label={translate('common.sortOrder')} />
            </Datagrid>
        </CustomList>
    );
};
